import useSWR from "swr";
import { useFetcher } from "./useFetcher";
import type { Entitlement } from "./getEntitlements";

export default function useClientEntitlements() {
  const fetcher = useFetcher();
  const { data, isLoading, error } = useSWR<Entitlement[] | null>(
    "/api/entitlement",
    fetcher,
  );
  return {
    entitlements: data || [],
    isLoadingEntitlements: isLoading,
    entitlementsError: error,
  };
}
